import { observer } from "mobx-react";
import { AUTO_PROCESS_EXECUTE, SINCE_UNIT, autoProcessExecuteOptionsList, autoProcessTriggerOptionsList, autoProcessValidatedQualifierOptionsList, sinceUnitOptionsList } from "../../../../../../constants";
import { FormFieldLine } from "../../../../../../../../components/form-field-line/form-field-line";
import { IOption, SelectDropdown } from "../../../../../../../../components/inputs/select-dropdown/select-dropdown";
import PolicyStore from "../../../../../../stores/policy-store";
import '../process-trigger-settings.scss';
import { AUTO_PROCESS_TRIGGER, AUTO_PROCESS_VALIDATED_QUALIFIER } from "../../../../../../../../models/User";
import { IValidationGroup } from "../../../../../../../../hooks/validation-group/validation-group-hook";

interface IProps {
    policy: PolicyStore,
    validationGroup: IValidationGroup,
}

const ExchangeTriggerSettings: React.FC<IProps> = observer(({ policy, validationGroup }) => {
    const selectedAutoProcessTrigger = autoProcessTriggerOptionsList().find(o => o.value === policy.autoExchangeTrigger);
    const selectedAutoProcessValidatedQualifier = autoProcessValidatedQualifierOptionsList().find(o => o.value === policy.autoExchangeValidatedQualifier);
    const selectedAutoProcessExecute = autoProcessExecuteOptionsList().find(o => o.value === policy.autoExchangeExecute);
    const selectedAutoProcessSinceUnit = sinceUnitOptionsList().find(o => o.value === policy.autoExchangeSinceUnit);

    const autoProcessSinceValueOptions = () => {
        const max = policy.autoExchangeSinceUnit === SINCE_UNIT.DAYS ? 14 : 24;

        const options = [] as IOption[];
        for (let i = 1; i <= max; i++) {
            options.push({
                value: i,
                label: i,
            });
        }

        return options;
    };
    const selectedAutoProcessSinceValue = autoProcessSinceValueOptions().find(o => o.value === policy.autoExchangeSinceValue);
    const showExecuteSince = policy.autoExchangeExecute && policy.autoExchangeExecute !== AUTO_PROCESS_EXECUTE.IMMEDIATELY;

    return (
        <>
            <FormFieldLine required label='Trigger' gridStyle={{lableWidth: {width: 100, type: 'px'}, childrenWidth: {width: 1, type: 'fr'}}}>
                <SelectDropdown
                    value={selectedAutoProcessTrigger}
                    options={autoProcessTriggerOptionsList()}
                    onChange={(v) => policy.setAutoExchangeTrigger(v?.value as AUTO_PROCESS_TRIGGER)}
                    required
                    validationGroup={validationGroup}
                    isSearchable={false}
                />
            </FormFieldLine>

            {policy.autoExchangeTrigger === AUTO_PROCESS_TRIGGER.ITEMS_VALIDATED &&
                <FormFieldLine required label='Validated is' gridStyle={{lableWidth: {width: 100, type: 'px'}, childrenWidth: {width: 1, type: 'fr'}}}>
                    <SelectDropdown
                        value={selectedAutoProcessValidatedQualifier}
                        options={autoProcessValidatedQualifierOptionsList()}
                        onChange={(v) => policy.setAutoExchangeValidatedQualifier(v?.value as AUTO_PROCESS_VALIDATED_QUALIFIER)}
                        required
                        validationGroup={validationGroup}
                        isSearchable={false}
                    />
                </FormFieldLine>
            }

            <FormFieldLine required label='Execute' gridStyle={{lableWidth: {width: 100, type: 'px'}, childrenWidth: {width: 1, type: 'fr'}}}>
                <SelectDropdown
                    required
                    validationGroup={validationGroup}
                    value={selectedAutoProcessExecute}
                    options={autoProcessExecuteOptionsList()}
                    onChange={(v) => policy.setAutoExchangeExecute(v?.value as AUTO_PROCESS_EXECUTE)}
                    isSearchable={false}
                />
            </FormFieldLine>

            {showExecuteSince &&
                <FormFieldLine label='' gridStyle={{lableWidth: {width: 100, type: 'px'}, childrenWidth: {width: 1, type: 'fr'}}}>
                    <div className="execute-since-fields">
                        <SelectDropdown
                            value={selectedAutoProcessSinceValue}
                            options={autoProcessSinceValueOptions()}
                            onChange={(v) => policy.setAutoExchangeSinceValue(v?.value as number)}
                            validationGroup={validationGroup}
                            required
                            isSearchable={false}
                        />

                        <SelectDropdown
                            value={selectedAutoProcessSinceUnit}
                            options={sinceUnitOptionsList()}
                            onChange={(v) => policy.setAutoExchangeSinceUnit(v?.value as SINCE_UNIT)}
                            validationGroup={validationGroup}
                            required
                            isSearchable={false}
                        />
                    </div>
                </FormFieldLine>
            }
        </>
    )
});

export default ExchangeTriggerSettings;